import React, { useEffect, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import highchartsGantt from "highcharts/modules/gantt";
import { useTranslation } from "react-i18next";
import TreegridModule from "highcharts/modules/treegrid";

TreegridModule(Highcharts);
highchartsGantt(Highcharts);

(function (H: any) {
  H.wrap(
    H._modules["Core/Axis/TreeGrid/TreeGridAxis.js"].prototype,
    "collapse",
    function (proceed: any, node: any) {
      //@ts-ignore
      H.fireEvent(this.axis, "collapse", { axis: this.axis, node: node });
      //@ts-ignore
      const ret = proceed.apply(this, Array.prototype.slice.call(arguments, 1));
      //@ts-ignore
      H.fireEvent(this.axis, "afterCollapse", { axis: this.axis, node: node });

      return ret;
    }
  );

  H.wrap(
    H._modules["Core/Axis/TreeGrid/TreeGridAxis.js"].prototype,
    "expand",
    function (proceed: any, node: any) {
      //@ts-ignore
      H.fireEvent(this.axis, "expand", { axis: this.axis, node: node });
      //@ts-ignore
      const ret = proceed.apply(this, Array.prototype.slice.call(arguments, 1));
      //@ts-ignore
      H.fireEvent(this.axis, "afterExpand", { axis: this.axis, node: node });

      return ret;
    }
  );
})(Highcharts);

interface ganttChartProps {
  timezoneOffset: number;
  options: HighchartsReact.Props;
  style?: React.CSSProperties;
}

const ptBR = {
  months: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],
  shortMonths: [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ],
  weekdays: [
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sábado",
  ],
};

const en = {
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  shortMonths: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  weekdays: [
    "Sunday",
    "Second",
    "Third",
    "Fourth",
    "Fifth",
    "Friday",
    "Saturday",
  ],
};

const es = {
  months: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  shortMonths: [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ],
  weekdays: [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ],
};

const GanttChart: React.FC<ganttChartProps> = (props) => {
  const { i18n } = useTranslation("translation");
  const [ganttConfig, setGanttConfig] = useState<any>({
    time: {
      timezoneOffset: props.timezoneOffset,
    },
  });

  useEffect(() => {
    if (i18n.language === "pt-BR") {
      setGanttConfig({ ...ganttConfig, lang: ptBR });
    } else if (i18n.language === "es") {
      setGanttConfig({ ...ganttConfig, lang: es });
    } else {
      setGanttConfig({ ...ganttConfig, lang: en });
    }
    Highcharts.setOptions(ganttConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return (
    <div style={props.style}>
      <HighchartsReact
        highcharts={Highcharts}
        constructorType={"ganttChart"}
        allowChartUpdate={true}
        immutable={true}
        options={props.options}
      />
    </div>
  );
};

export default GanttChart;
